import React, { createContext, useState, useContext } from 'react';
import { readSessionAccess, saveSessionAccess, clearSessionAccess } from './sessionAccess';
// import { initialState, reducer } from '../store/reducers';
export const Context = createContext();

const Provider = ({ children }) => {
  // Identity and access must come from the same tab, never another tab's login.
  const [restoredSession] = useState(readSessionAccess);
  const [token, setToken] = useState(restoredSession.token);
  const [userId, setUserId] = useState(restoredSession.userId);
  const [userName, setUserName] = useState(restoredSession.userName);
  const [userLastname, setUserLastname] = useState(restoredSession.userLastname);
  const [userFullname, setUserFullname] = useState(restoredSession.userFullname);
  const [userProfile, setUserProfile] = useState(restoredSession.userProfile);
  const [userIdProfile, setUserIdProfile] = useState(restoredSession.userIdProfile);
  const [userOrchard, setUserOrchard] = useState(restoredSession.userOrchard);
  const [moduleUser, setModuleUser] = useState(restoredSession.moduleUser);
  const [userClient, setUserClient] = useState(restoredSession.userClient);
  const [initialRoute, setInitialRoute] = useState(restoredSession.initialRoute);
  const [userSpecies, setUserSpecies] = useState(restoredSession.userSpecies);

  const setUpdateUserFullname = (fullname) => {
    setUserFullname(fullname);
    window.sessionStorage.setItem('userFullname', userFullname);
  };

  const setUserSpeciesHandler = (userSpecies) => {
    setUserSpecies(userSpecies);
    saveSessionAccess({ userId, userProfile, userOrchard, moduleUser, userClient, userSpecies });
  };

  // const [projectSelectedUser, setProjectSelectedUser] = useState(
  //   JSON.parse(localStorage.getItem('userProjectSelected'))
  // );

  // const [projectsListUser, setProjectListUser] = useState(
  //   JSON.parse(localStorage.getItem('userProjectList'))
  // );

  // console.log(projectSelectedUser, projectsListUser, "en el context");
  const value = {
    token: token,
    userId: userId,
    userName: userName,
    userLastname: userLastname,
    userFullname: userFullname,
    userProfile: userProfile,
    userIdProfile: userIdProfile,
    userOrchard: userOrchard,
    moduleUser: moduleUser,
    userClient: userClient,
    initialRoute: initialRoute,
    userSpecies: userSpecies,
    login: (
      token,
      userId,
      userName,
      userLastname,
      userFullname,
      userProfile,
      userIdProfile,
      userOrchard,
      moduleUser,
      userClient,
      initialRoute,
      userSpecies = []
    ) => {
      saveSessionAccess({ userId, userProfile, userOrchard, moduleUser, userClient, userSpecies });
      setToken(token);
      setUserId(userId);
      setUserName(userName);
      setUserLastname(userLastname);
      setUserFullname(userFullname);
      setUserProfile(userProfile);
      setUserOrchard(userOrchard);
      setModuleUser(moduleUser);
      setUserIdProfile(userIdProfile);
      setUserClient(userClient);
      setInitialRoute(initialRoute);
      setUserSpecies(userSpecies);
      window.sessionStorage.setItem('token', token);
      window.sessionStorage.setItem('userId', userId);
      window.sessionStorage.setItem('userName', userName);
      window.sessionStorage.setItem('userLastname', userLastname);
      window.sessionStorage.setItem('userFullname', userFullname);
      window.sessionStorage.setItem('initialRoute', initialRoute);
      // window.sessionStorage.setItem('userProfile', userProfile);
      window.sessionStorage.setItem('userIdProfile', userIdProfile);
    },
    logout: () => {
      clearSessionAccess();
      setToken(null);
      setUserId(null);
      setUserName(null);
      setUserLastname(null);
      setUserFullname(null);
      setUserProfile(null);
      setUserOrchard(null);
      setUserIdProfile(null);
      setModuleUser(null);
      setUserClient(null);
      setInitialRoute(null);
      setUserSpecies(null);
      window.sessionStorage.removeItem('token');
      window.sessionStorage.removeItem('userId');
      window.sessionStorage.removeItem('userName');
      window.sessionStorage.removeItem('userLastname');
      window.sessionStorage.removeItem('userFullname');
      window.sessionStorage.removeItem('initialRoute');
      // window.sessionStorage.removeItem('userProfile');
      localStorage.removeItem('userProfile');
      window.sessionStorage.removeItem('userIdProfile');
      // localStorage.removeItem('userProjectSelected');
      localStorage.removeItem('userOrchard');
      localStorage.removeItem('moduleUser');
      localStorage.removeItem('userClient');
      localStorage.removeItem('userSpecies');

      // const tagManagerArgs = {
      //   gtmId: 'GTM-W87D5MS',
      //   dataLayer: {
      //     userId: null,
      //     clientName: null,
      //     fullName: null,
      //     userName: null,
      //   },
      // };
      // TagManager.initialize(tagManagerArgs);
      if (window.dataLayer) {
        // Clear the entire dataLayer
        window.dataLayer = [];
      }
    },
    setUserFullname: setUpdateUserFullname,
    setUserSpeciesHandler: setUserSpeciesHandler,

    // projectSelected: projectSelectedUser,
    // projectList: projectsListUser,
    // setProjectList: (projects) => {
    // 	setProjectListUser(projects);
    // 	// localStorage.setItem('userProjectList', JSON.stringify(projects));
    // },
    // setProjectSelected: (project) => {
    // 	setProjectSelectedUser(project);
    // 	localStorage.setItem('userProjectSelected', JSON.stringify(project));
    // },
    // dispatch
  };
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
export const useStore = () => useContext(Context);
export default {
  Provider,
  Consumer: Context.Consumer,
};
